import React from 'react'
import AdItem from '../AdItem/AdItem'
import { setting } from "../../Common/setting"
import Slider from 'react-slick'
import "./AdsDetails.css"
import { useSelector } from 'react-redux'


export default function AdsDetails() {
    
    const {BookWormUser} = useSelector((state) => state)
    const {userInfo} = BookWormUser
    const { ads } = userInfo


    console.log("ads in user view my ads details : ",ads)
    console.log(ads.pending.length === 0 && ads.approved.length === 0 && ads.sold.length === 0)
  return (
    <div className="AdsDetails">
        {
              (ads.pending.length === 0 && ads.approved.length === 0) && (ads.sold.length === 0) ?
                 <div className="Ad-container">
                    <h3 style={{color:"#fae5df"}} >No Ads Found</h3>
                 </div>  : ""
        }
        {(ads.pending.length)?<div className='Ad-container'>
              <h2>Unapproved Ads of {userInfo.name}</h2>
                
                {(ads.pending.length <=3)? 
                <div className='row'>
                    {
                        ads.pending.map((element) => {
                       
                        return (

                        <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                            <AdItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]}/>
                        </div>
                         
                        )})
                    }
                </div>:

                <Slider {...setting}>
                {
                    ads.pending.map((element) => {
                        
                        return (
                            <AdItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]}/>
                    )})
                }
                </Slider>
                }
        </div>:''}
        {(ads.approved.length)?<div className='Ad-container'>
              <h2>Approved Ads of {userInfo.name}</h2>
                
                {(ads.approved.length <=3)? 
                <div className='row'>
                    {
                        ads.approved.map((element) => {
                       
                        return (

                        <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                            <AdItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0].name}/>
                        </div>
                         
                        )})
                    }
                </div>:

                <Slider {...setting}>
                {
                    ads.approved.map((element) => {
                       
                        return (
                            <AdItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0].name}/>
                    )})
                }
                </Slider>
                }
        </div>:''}

        {(ads.sold.length)?<div className='Ad-container'>
              <h2>Sold Ads of {userInfo.name}</h2>
                
                {(ads.sold.length <=3)? 
                <div className='row'>
                    {
                        ads.sold.map((element) => {
                       
                        return (

                        <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                            <AdItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0].name}/>
                        </div>
                         
                        )})
                    }
                </div>:

                <Slider {...setting}>
                {
                    ads.sold.map((element) => {
                     
                        return (
                            <AdItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0].name}/>
                    )})
                }
                </Slider>
                }
        </div>:''}
        
    </div>
  )
}
